import { z } from 'zod'

export const schema = z.object({})

export type schemaType = z.infer<typeof schema>
